export default "/_next/static/images/5a7129cfbdfd928edd1b282de0d65e84.png";